import React from 'react';
import type { LegalDoc } from './siteLegal';
import './LegalPage.css';

const LOCALE: Record<string, string> = { fi: 'fi-FI', en: 'en-GB', de: 'de-DE' };

/** Renders one site-specific legal text (siteLegal.ts) with the existing legal-page styles. */
const LegalDocument: React.FC<{ doc: LegalDoc; lang: string }> = ({ doc, lang }) => {
  const date = new Intl.DateTimeFormat(LOCALE[lang] ?? 'en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' })
    .format(new Date(`${doc.updated}T00:00:00Z`));
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>{doc.title}</h1>
          {/* A fixed date: the old pages printed the build date as "last updated". */}
          <p className="last-updated">{doc.updatedLabel} <time dateTime={doc.updated}>{date}</time></p>
          {doc.intro?.map((p, i) => <p key={i}>{p}</p>)}
          {doc.sections.map((s) => (
            <section className="legal-section" key={s.h2}>
              <h2>{s.h2}</h2>
              {s.paragraphs?.map((p, i) => <p key={i}>{p}</p>)}
              {s.list && <ul>{s.list.map((li, i) => <li key={i}>{li}</li>)}</ul>}
              {s.after?.map((p, i) => <p key={i}>{p}</p>)}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegalDocument;
